import React from 'react';
import Icon from '@mui/material/Icon';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import MDBox from 'components/MDBox';

export function SoftIcon({ icon, tone = 'teal' }) {
  const theme = useMuiTheme();
  const tones = {
    teal: { bg: 'rgba(0,150,136,.14)', fg: '#009688' },
    violet: { bg: 'rgba(124,58,237,.14)', fg: '#7c3aed' },
    amber: { bg: 'rgba(255,122,0,.14)', fg: '#ff7a00' },
    sky: { bg: 'rgba(2,132,199,.14)', fg: '#0284c7' },
  };
  const t = tones[tone] || tones.teal;

  return (
    <MDBox
      sx={{
        width: 44,
        height: 44,
        borderRadius: '16px',
        display: 'grid',
        placeItems: 'center',
        background: t.bg,
        color: t.fg,
        border: `1px solid rgba(0,0,0,.06)`,
        flex: '0 0 auto',
      }}
    >
      <Icon sx={{ fontSize: 22 }}>{icon}</Icon>
    </MDBox>
  );
}
